
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SeoJsonLdProps {
  type: 'WebSite' | 'WebPage' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SeoJsonLd({ type, data }: SeoJsonLdProps) {
  const location = useLocation();
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useEffect(() => {
    const existingScript = document.querySelector('script[data-seo-jsonld]');
    if (existingScript) {
      existingScript.remove();
    }

    let jsonLd: Record<string, unknown> = {};

    if (type === 'WebSite') {
      jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '폐업지원금 간편 계산기',
        url: siteUrl,
        description: '7가지 정보를 입력하면 폐업지원금을 즉시 확인가능! 정확한 폐업지원금 계산 서비스를 제공합니다.',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: siteUrl + '/?q={search_term_string}'
          },
          'query-input': 'required name=search_term_string'
        }
      };
    } else if (type === 'WebPage') {
      jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '폐업지원금 간편 계산기',
        url: siteUrl + location.pathname,
        description: '7가지 정보를 입력하면 폐업지원금을 즉시 확인가능! 정확한 폐업지원금 계산 서비스를 제공합니다.',
        inLanguage: 'ko-KR',
        isPartOf: {
          '@type': 'WebSite',
          name: '폐업지원금 간편 계산기',
          url: siteUrl
        },
        ...data
      };
    } else if (type === 'FAQPage') {
      jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: data?.mainEntity || []
      };
    }

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-seo-jsonld', 'true');
    
    // Add error handling for JSON.stringify
    try {
      script.textContent = JSON.stringify(jsonLd);
    } catch (error) {
      console.error('Error stringifying JSON-LD data:', error);
      return;
    }
    
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.querySelector('script[data-seo-jsonld]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [type, data, location.pathname, siteUrl]);

  return null;
}
